"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/Tinymce/index"));
var _product = require("@/api/product");
var _validate = require("@/utils/validate");
var _vuex = require("vuex");
var _permission = require("@/utils/permission");
var _creatAttr = _interopRequireDefault(require("../components/creatAttr"));
var _ZBKJIutil = require("@/utils/ZBKJIutil");
var _auth = require("@/utils/auth");
var _edit = _interopRequireDefault(require("@/components/Category/edit.vue"));
var _merchant = require("@/api/merchant");
var _systemForm = require("@/api/systemForm");
var _hotel = require("@/api/hotel");
var _useProduct2 = require("@/hooks/use-product");
var _hotel2 = _interopRequireDefault(require("@/mixins/hotel"));
var _default2 = require("./default");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorKeys(e) { var n = Object(e), r = []; for (var t in n) r.unshift(t); return function e() { for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e; return e.done = !0, e; }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 权限判断函数
var _useProduct = (0, _useProduct2.useProduct)(),
  handlerCreatFromUse = _useProduct.handlerCreatFromUse;
var _default = exports.default = {
  name: 'roomProductAdd',
  directives: {
    // 计算是否滚动到最下面
    selectLoadMore: {
      bind: function bind(el, binding) {
        // 获取element-ui定义好的scroll盒子
        var SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
        SELECTWRAP_DOM.addEventListener('scroll', function () {
          var condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
          if (condition) {
            binding.value();
          }
        });
      }
    }
  },
  mixins: [_hotel2.default],
  //此js存放酒店的部分函数方法
  components: {
    edit: _edit.default,
    Tinymce: _index.default,
    creatAttr: _creatAttr.default
  },
  data: function data() {
    return {
      limitArr: [],
      //限购规则列表
      backArr: [],
      // 退货规则列表
      htmlKey: 0,
      form: 2,
      url: '',
      copyConfig: {},
      labelarr: [],
      isDisabled: this.$route.params.isDisabled === '1' ? true : false,
      isCopy: this.$route.params.isCopy === '1' ? true : false,
      //是否是采集
      props2: {
        children: 'childList',
        label: 'name',
        value: 'id',
        multiple: true,
        emitPath: false,
        checkStrictly: true
      },
      props1: {
        children: 'childList',
        label: 'name',
        value: 'id',
        multiple: false,
        emitPath: false
      },
      tabs: [],
      fullscreenLoading: false,
      props: {
        multiple: true
      },
      active: 0,
      manyTabTit: {},
      manyTabDate: {},
      // 生成规格表格中的头部标题
      grid2: {
        xl: 24,
        lg: 24,
        md: 24,
        sm: 24,
        xs: 24
      },
      isBtn: false,
      manyFormValidate: [],
      currentTab: '1',
      isChoice: '',
      grid: {
        xl: 24,
        lg: 24,
        md: 24,
        sm: 24,
        xs: 24
      },
      ruleValidate: {
        name: [{
          required: true,
          message: '请输入酒店名称',
          trigger: 'blur'
        }],
        categoryId: [{
          required: true,
          message: '请选择平台酒店分类',
          trigger: 'change'
        }],
        intro: [{
          required: true,
          message: '请输入酒店简介',
          trigger: 'blur'
        }],
        image: [{
          required: true,
          message: '请上传酒店图',
          trigger: 'change'
        }],
        sliderImages: [{
          required: true,
          message: '请上传酒店轮播图',
          type: 'array',
          trigger: 'change'
        }]
      },
      tempRoute: {},
      keyNum: 0,
      isShowAttr: false,
      guaranteeList: [],
      brandList: [],
      search: {
        limit: this.$constants.page.limit[0],
        page: 1,
        cid: '',
        brandName: ''
      },
      totalPage: 0,
      total: 0,
      loading: false,
      loadingBtn: false,
      isShowGroup: 'alone',
      guaranteeGroupList: [],
      guaranteeNew: [],
      guaranteeName: [],
      multiples: true,
      productClassify: [],
      //平台酒店分类
      productType: [{
        tit: '普通酒店',
        id: 0,
        tit2: '实体货物'
      }, {
        tit: '云盘酒店',
        id: 5,
        tit2: '同一链接发货'
      }, {
        tit: '卡密酒店',
        id: 6,
        tit2: '不同充值码发货'
      }],
      upload: {
        videoIng: false // 是否显示进度条；
      },
      videoLink: '',
      //视频地址
      progress: 10,
      // 进度条默认0
      myHeaders: {
        'X-Token': (0, _auth.getToken)()
      },
      editDialogConfig: {
        visible: false,
        isCreate: 0,
        // 0=创建，1=编辑
        prent: {},
        // 父级对象
        data: {},
        biztype: {
          name: '产品分类',
          value: 1,
          shortName: '产品'
        } // 统一主业务中的目录类型
      },
      //酒店分类
      isSwitch: false,
      //商户开关
      productSwitch: false,
      //酒店是否需要审核 true需要审核，false免审
      formDynamics: {
        ruleName: '',
        ruleValue: []
      }
    };
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.bus.$emit('onTagsViewRefreshRouterView', this.$route.path);
    next();
  },
  computed: _objectSpread(_objectSpread({
    visitedViews: function visitedViews() {
      return this.$store.state.tagsView.visitedViews;
    }
  }, (0, _vuex.mapState)({
    systemFormList: function systemFormList(state) {
      return state.mobildConfig.systemFormList;
    }
  })), (0, _vuex.mapGetters)(['merPlatProductClassify', 'merProductClassify', 'productBrand', 'shippingTemplates'])),
  created: function created() {
    this.tempRoute = Object.assign({}, this.$route);
  },
  mounted: function mounted() {
    this.formValidate.sliderImages = [];
    if ((0, _permission.checkPermi)(['merchant:plat:product:category:cache:tree'])) this.$store.dispatch('product/getAdminProductClassify');
    if (!localStorage.getItem('merProductClassify') && (0, _permission.checkPermi)(['merchant:product:category:cache:tree'])) this.$store.dispatch('product/getMerProductClassify');
    if ((0, _permission.checkPermi)(['merchant:plat:product:brand:cache:list'])) this.$store.dispatch('product/getMerProductBrand');
    if (!localStorage.getItem('systemFormList') && (0, _permission.checkPermi)(['merchant:system:form:page'])) this.getSystemFormList();
    this.setTagsViewTitle();
    if (this.$route.params.id && this.$route.params.id != 0) {
      if ((0, _permission.checkPermi)(['merchant:product:info'])) this.getInfo();
    } else {
      this.isShowAttr = true;
    }
    if (this.isCopy && (0, _permission.checkPermi)(['merchant:plat:product:brand:cache:list'])) this.getCopyConfig();
    this.productClassify = this.addDisabled(this.merPlatProductClassify);
    this.getProductAuditSwitchInfo();
    this.getbacklist();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    // 获取退货/限购规则列表
    getbacklist: function getbacklist() {
      var _this = this;
      (0, _product.currentlimitListApi)().then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                console.log(res);
                _this.limitArr = res.list;
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
      (0, _product.currentlreturnListApi)().then(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(res) {
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                console.log(res);
                _this.backArr = res.list;
              case 1:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    //创建、编辑表单
    handlerCreatFrom: function handlerCreatFrom(id, type) {
      handlerCreatFromUse(id, type);
    },
    //系统表单数据
    getSystemFormList: function () {
      var _getSystemFormList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _yield$systemFormPage, list;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return (0, _systemForm.systemFormPageApi)({
                page: 1,
                limit: 999
              });
            case 1:
              _yield$systemFormPage = _context3.v;
              list = _yield$systemFormPage.list;
              this.$store.commit('mobildConfig/SET_SystemForm', list);
              localStorage.setItem('systemFormList', JSON.stringify(list));
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function getSystemFormList() {
        return _getSystemFormList.apply(this, arguments);
      }
      return getSystemFormList;
    }(),
    //获取商户端商户酒店审核开关信息
    getProductAuditSwitchInfo: function getProductAuditSwitchInfo() {
      var _this2 = this;
      (0, _merchant.productAuditSwitchInfoApi)().then(/*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(res) {
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.n) {
              case 0:
                _this2.isSwitch = res.isSwitch;
                _this2.productSwitch = res.productSwitch;
              case 1:
                return _context4.a(2);
            }
          }, _callee4);
        }));
        return function (_x3) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    hideEditDialog: function hideEditDialog() {
      var _this3 = this;
      this.editDialogConfig.prent = {};
      this.editDialogConfig.type = 0;
      this.editDialogConfig.visible = false;
      setTimeout(function () {
        _this3.$store.dispatch('product/getMerProductClassify');
      }, 200);
    },
    //视频上传前
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isJPG = file.type === 'video/mp4';
      var isLt2M = file.size / 10240 / 10240 < 2;
      if (!isJPG) {
        this.$message.error('上传视频只能是 mp4 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传视频不能超过 20MB!');
      }
      return isJPG && isLt2M;
    },
    // 上传
    handleUploadForm: function () {
      var _handleUploadForm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(param) {
        var formData, data, loading, res, _t;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              formData = new FormData();
              data = {
                model: 'product',
                pid: 0
              };
              loading = this.$loading({
                lock: true,
                text: '上传中，请稍候...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              formData.append('multipart', param.file);
              _context5.p = 1;
              _context5.n = 2;
              return (0, _ZBKJIutil.uploadImage)(formData, data);
            case 2:
              res = _context5.v;
              this.upload.videoIng = true;
              this.videoLink = res.url;
              this.progress = 100;
              loading.close();
              _context5.n = 4;
              break;
            case 3:
              _context5.p = 3;
              _t = _context5.v;
              loading.close();
            case 4:
              return _context5.a(2);
          }
        }, _callee5, this, [[1, 3]]);
      }));
      function handleUploadForm(_x4) {
        return _handleUploadForm.apply(this, arguments);
      }
      return handleUploadForm;
    }(),
    // 删除视频；
    delVideo: function delVideo() {
      this.$set(this, 'videoLink', '');
    },
    //限制平台酒店分类只能选择第三级
    addDisabled: function addDisabled(dropdownList) {
      var _this4 = this;
      var list = [];
      try {
        dropdownList.forEach(function (e, index) {
          var e_new = {
            id: e.id,
            name: e.name,
            level: e.level,
            pid: e.pid,
            isShow: e.isShow
          };
          if (!e.childList && (e.level === 1 || e.level === 2)) {
            e_new = _objectSpread(_objectSpread({}, e_new), {}, {
              disabled: true
            });
          }
          if (e.childList) {
            var childList = _this4.addDisabled(e.childList);
            e_new = _objectSpread(_objectSpread({}, e_new), {}, {
              childList: childList
            });
          }
          list.push(e_new);
        });
      } catch (error) {
        return [];
      }
      return list;
    },
    /**
     * 复制酒店转图片路径
     * @param sliderImage轮播图, attrValue规格
     */
    getShopImg: function () {
      var _getShopImg = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(sliderImage, attrValue) {
        var _this5 = this;
        var imgList, attrs, ShopImg, result;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              imgList = _toConsumableArray(JSON.parse(sliderImage));
              attrValue.map(function (item) {
                return imgList.push(item.image);
              });
              attrs = _toConsumableArray(new Set(imgList));
              ShopImg = [];
              attrs.map(function (item) {
                ShopImg.push({
                  key: item,
                  img: item
                });
              });
              _context6.n = 1;
              return this.getShopImgUpload(ShopImg, []);
            case 1:
              result = _context6.v;
              this.formValidate.images = this.formValidate.images.map(function (item, index) {
                if (result[index].key && item === result[index].key) {
                  return result[index].img;
                } else {
                  _this5.formValidate.images.splice(index, 1);
                }
              });
              this.ManyAttrValue.map(function (item, index) {
                result.map(function (items, index) {
                  if (items.key && item.image === items.key) {
                    return item.image = items.img;
                  }
                });
              });
              this.fullscreenLoading = false;
            case 2:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function getShopImg(_x5, _x6) {
        return _getShopImg.apply(this, arguments);
      }
      return getShopImg;
    }(),
    getShopImgUpload: function () {
      var _getShopImgUpload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(attrs, arr) {
        var key, res, _t2, _t3;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _t2 = _regeneratorKeys(attrs);
            case 1:
              if ((_t3 = _t2()).done) {
                _context7.n = 3;
                break;
              }
              key = _t3.value;
              _context7.n = 2;
              return this.getImgData(attrs[key].img || attrs[key].sattDir);
            case 2:
              res = _context7.v;
              arr.push({
                key: attrs[key].img || attrs[key].imgsattDir,
                img: res
              });
              _context7.n = 1;
              break;
            case 3:
              return _context7.a(2, arr);
          }
        }, _callee7, this);
      }));
      function getShopImgUpload(_x7, _x8) {
        return _getShopImgUpload.apply(this, arguments);
      }
      return getShopImgUpload;
    }(),
    /**
     * 复制酒店图片路径请求接口
     * @param imgUrl
     * @returns {Promise<any>}
     */
    getImgData: function getImgData(imgUrl) {
      var _this6 = this;
      return new Promise(function (resolve, reject) {
        shopImgUploadApi({
          imgUrl: imgUrl,
          respType: 1,
          uploadType: 1
        }).then(function (res) {
          if (res.errcode > 0) {
            _this6.fullscreenLoading = false;
            _this6.$message.error(res.errmsg);
            resolve('');
          } else {
            resolve(res.img_info.temp_img_url);
          }
        });
      });
    },
    getCopyConfig: function getCopyConfig() {
      var _this7 = this;
      (0, _product.copyConfigApi)().then(function (res) {
        _this7.copyConfig = res;
      });
    },
    getLabelarr: function getLabelarr(attr) {
      this.labelarr = attr;
    },
    changeNodes: function changeNodes(data) {
      if (data.length > 0) {
        for (var i = 0; i < data.length; i++) {
          if (!data[i].childList || data[i].childList.length < 1) {
            data[i].childList = undefined;
          } else {
            this.changeNodes(data[i].childList);
          }
        }
      }
      return data;
    },
    onChangeCategory: function onChangeCategory() {
      this.formValidate.brandId = '';
      this.brandList = [];
      this.getbrandList();
      this.brandList.push({
        name: '其他',
        id: 0
      });
    },
    // 下拉加载更多
    selectLoadMore: function selectLoadMore() {
      this.search.page = this.search.page + 1;
      if (this.search.page > this.totalPage) return;
      this.getbrandList(); // 请求接口
    },
    // 远程搜索
    remoteMethod: function remoteMethod(query) {
      var _this8 = this;
      this.loading = true;
      this.search.brandName = query;
      this.search.page = 1;
      setTimeout(function () {
        _this8.loading = false;
        _this8.getbrandList(); // 请求接口
      }, 200);
    },
    // 品牌列表
    getbrandList: function getbrandList() {
      var _this9 = this;
      this.search.cid = this.formValidate.categoryId;
      (0, _product.brandListApi)(this.search).then(function (res) {
        _this9.totalPage = res.totalPage;
        _this9.total = res.total;
        _this9.brandList = _this9.brandList.concat(res.list);
      });
    },
    proving1: function proving1(e) {
      this.formValidate.sort = e.target.value.replace(/[^\.\d]/g, '');
      this.formValidate.sort = e.target.value.replace('.', '');
    },
    handleCloseCoupon: function handleCloseCoupon(tag) {
      this.formValidate.coupons.splice(this.formValidate.coupons.indexOf(tag), 1);
      this.formValidate.couponIds.splice(this.formValidate.couponIds.indexOf(tag.id), 1);
    },
    setTagsViewTitle: function setTagsViewTitle() {
      if (this.$route.params.id && this.$route.params.id != 0) {
        var title = this.isDisabled ? '酒店详情' : '编辑酒店';
        var route = Object.assign({}, this.tempRoute, {
          title: "".concat(title, "-").concat(this.$route.params.id)
        });
        this.$store.dispatch('tagsView/updateVisitedView', route);
      } else {
        if (this.isCopy) {
          var _title = '采集酒店';
          var _route = Object.assign({}, this.tempRoute, {
            title: "".concat(_title)
          });
          this.$store.dispatch('tagsView/updateVisitedView', _route);
        }
      }
    },
    // 详情
    getInfo: function getInfo() {
      var _this0 = this;
      this.fullscreenLoading = true;
      (0, _hotel.roomTypeDetailApi)({
        id: this.$route.params.id
      }).then(/*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(res) {
          return _regenerator().w(function (_context8) {
            while (1) switch (_context8.n) {
              case 0:
                _context8.n = 1;
                return _this0.getData(res, 'add');
              case 1:
                _this0.isShowAttr = true;
                _this0.fullscreenLoading = false;
              case 2:
                return _context8.a(2);
            }
          }, _callee8);
        }));
        return function (_x9) {
          return _ref4.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this0.fullscreenLoading = false;
      });
    },
    handleRemove: function handleRemove(i) {
      this.formValidate.sliderImages.splice(i, 1);
    },
    // 上一步
    handleSubmitUp: function handleSubmitUp() {
      this.currentTab = (Number(this.currentTab) - 1).toString();
    },
    // 下一步
    handleSubmitNest: function handleSubmitNest(name) {
      var _this1 = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this1.currentTab = (Number(_this1.currentTab) + 1).toString();
        } else {
          if (!_this1.formValidate.name || !_this1.formValidate.categoryId || !_this1.formValidate.keyword || !_this1.formValidate.intro || !_this1.formValidate.image || !_this1.formValidate.sliderImages) {
            _this1.$message.warning('请填写完整酒店信息！');
          }
        }
      });
    },
    //保存接口数据更新
    getFromData: function getFromData() {
      if (this.videoLink) {
        //如果有视频主图，将视频链接插入到轮播图第一的位置
        this.formValidate.sliderImages.unshift(this.videoLink);
      }
      var data = _objectSpread(_objectSpread({}, this.formValidate), {}, {
        keyword: this.labelarr.join(','),
        sliderImage: JSON.stringify(this.formValidate.sliderImages)
      });
      return data;
    },
    //是否自动上架
    automaticListing: function automaticListing() {
      var _this10 = this;
      this.$confirm(this.productSwitch ? '审核通过之后是否自动上架？' : '操作之后是否自动上架？', '提示', {
        confirmButtonText: '上架',
        cancelButtonText: '不用了',
        type: 'warning',
        closeOnClickModal: false,
        distinguishCancelAndClose: true,
        customClass: 'deleteConfirm'
      }).then(function () {
        _this10.formValidate.isAutoUp = true;
        _this10.postData();
      }).catch(function (action) {
        if (action === 'cancel') {
          _this10.formValidate.isAutoUp = false;
          _this10.postData();
          // 调用取消按钮的方法
        } else if (action === 'close') {
          // 调用关闭按钮的方法
        }
      });
    },
    //保存并审核
    handleSubmitAndAudit: function handleSubmitAndAudit(name) {
      var _this11 = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          //  this.getFromData();
          _this11.formValidate.isAutoSubmitAudit = true;
          _this11.automaticListing();
        } else {
          if (!_this11.formValidate.name || !_this11.formValidate.cateId || !_this11.formValidate.keyword || !_this11.formValidate.unitName || !_this11.formValidate.intro || !_this11.formValidate.image || !_this11.formValidate.sliderImages) {
            _this11.$message.warning('请填写完整酒店信息！');
          }
        }
      });
    },
    // 保存
    handleSubmit: function handleSubmit(name) {
      var _this12 = this;
      // let data = this.getFromData();
      this.$refs[name].validate(function (valid) {
        if (valid) {
          // this.getFromData();
          //免审酒店，保存的时候弹出上架弹窗，条件：店铺开启 && 店铺免审
          if (_this12.isSwitch && !_this12.productSwitch) {
            _this12.formValidate.isAutoSubmitAudit = false;
            _this12.automaticListing();
          } else {
            _this12.formValidate.isAutoUp = false;
            _this12.formValidate.isAutoSubmitAudit = false;
            _this12.postData();
          }
        } else {
          if (!_this12.formValidate.name || !_this12.formValidate.cateId || !_this12.formValidate.keyword || !_this12.formValidate.unitName || !_this12.formValidate.intro || !_this12.formValidate.image || !_this12.formValidate.sliderImages) {
            _this12.$message.warning('请填写完整酒店信息！');
          }
        }
      });
    },
    // 新增保存数据
    postData: function postData() {
      var _this13 = this;
      this.loadingBtn = true;
      var data = this.getFromData();
      parseFloat(this.$route.params.id) > 0 ? (0, _hotel.roomTypeUpdateApi)(data).then(/*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(res) {
          return _regenerator().w(function (_context9) {
            while (1) switch (_context9.n) {
              case 0:
                _this13.$message.success('编辑成功');
                setTimeout(function () {
                  _this13.$router.push({
                    path: '/hotel/room-type'
                  });
                }, 500);
                _this13.closeSelectedTag();
                _this13.loadingBtn = false;
              case 1:
                return _context9.a(2);
            }
          }, _callee9);
        }));
        return function (_x0) {
          return _ref5.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this13.loadingBtn = false;
      }) : (0, _hotel.roomTypeCreateApi)(data).then(/*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(res) {
          return _regenerator().w(function (_context0) {
            while (1) switch (_context0.n) {
              case 0:
                _this13.$message.success('新增成功');
                setTimeout(function () {
                  _this13.$router.push({
                    path: '/hotel/room-type'
                  });
                }, 500);
                _this13.closeSelectedTag();
                _this13.loadingBtn = false;
              case 1:
                return _context0.a(2);
            }
          }, _callee0);
        }));
        return function (_x1) {
          return _ref6.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this13.loadingBtn = false;
      });
    },
    isActive: function isActive(route) {
      return route.path === this.$route.path;
    },
    closeSelectedTag: function closeSelectedTag() {
      var that = this;
      that.$store.dispatch('tagsView/delView', that.$route).then(function (_ref7) {
        var visitedViews = _ref7.visitedViews;
        if (that.isActive(that.$route)) {
          that.toLastView(visitedViews, that.$route);
        }
      });
    },
    toLastView: function toLastView(visitedViews, view) {
      var latestView = visitedViews.slice(-1)[0];
      if (latestView) {
        this.$router.push(latestView.fullPath);
      } else {
        // now the default is to redirect to the home page if there is no tags-view,
        // you can adjust it according to your needs.
        if (view.name === 'Dashboard') {
          // to reload home page
          this.$router.replace({
            path: '/redirect' + view.fullPath
          });
        } else {
          this.$router.push('/');
        }
      }
    },
    // 表单验证
    validate: function validate(prop, status, error) {
      if (status === false) {
        this.$message.warning(error);
      }
    },
    getFileType: function getFileType(fileName) {
      // 后缀获取
      var suffix = '';
      // 获取类型结果
      var result = '';
      try {
        var flieArr = fileName.split('.');
        suffix = flieArr[flieArr.length - 1];
      } catch (err) {
        suffix = '';
      }
      // fileName无后缀返回 false
      if (!suffix) {
        return false;
      }
      suffix = suffix.toLocaleLowerCase();
      // 图片格式
      var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
      // 进行图片匹配
      result = imglist.find(function (item) {
        return item === suffix;
      });
      if (result) {
        return 'image';
      }
      // 匹配 视频
      var videolist = ['mp4', 'm2v', 'mkv', 'rmvb', 'wmv', 'avi', 'flv', 'mov', 'm4v'];
      result = videolist.find(function (item) {
        return item === suffix;
      });
      if (result) {
        return 'video';
      }
      // 其他 文件类型
      return 'other';
    }
  }
};